import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { PanelMenu } from 'primereact/panelmenu';
import { useAuth } from '../../features/auth/contexts/AuthContext';
import LoginForm from '../../features/auth/components/LoginForm';
import Map from '../../features/map';
import Projects from '../../features/projects';
import Statuses from '../../features/statuses';
import Certifiers from '../../features/certifiers';

function AppLayout() {
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const navigate = useNavigate();
  const { isAuthenticated, loading, logout } = useAuth();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="flex justify-content-center align-items-center min-h-screen">
        <div className="text-center">
          <i className="pi pi-spin pi-spinner text-4xl text-primary"></i>
          <p className="mt-2">Cargando...</p>
        </div>
      </div>
    );
  }

  // Show login form if not authenticated
  if (!isAuthenticated) {
    return <LoginForm onLoginSuccess={() => {}} />;
  }

  const panelMenuItems = [
    {
      label: 'Mapa',
      icon: 'pi pi-map',
      command: () => {
        navigate('/admin/map');
        setSidebarVisible(false);
      }
    },
    {
      label: 'Proyectos',
      icon: 'pi pi-list',
      command: () => {
        navigate('/admin/projects/list');
        setSidebarVisible(false);
      }
    },
    {
      label: 'Estados',
      icon: 'pi pi-tags',
      command: () => {
        navigate('/admin/statuses');
        setSidebarVisible(false);
      }
    },
    {
      label: 'Certificadores',
      icon: 'pi pi-shield',
      command: () => {
        navigate('/admin/certifiers');
        setSidebarVisible(false);
      }
    }
  ];

  // Render full layout for all routes
  return (
    <div style={{ height: '100vh', width: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', padding: '0.5rem', backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
        <Button
          icon="pi pi-bars"
          className="p-button-text p-button-rounded"
          onClick={() => setSidebarVisible(true)}
        />
        <div style={{ flex: 1, textAlign: 'center' }}>
          <h3 style={{ margin: 0 }}>CENSAT Map</h3>
        </div>
        <Button
          icon="pi pi-sign-out"
          className="p-button-text p-button-rounded"
          onClick={() => logout()}
        />
      </div>

      {/* Main Content */}
      <div style={{ flex: 1, overflow: 'auto' }}>
        <Routes>
          {/* Redirect root to /admin/map - handled in App.js */}
          {/* Map route */}
          <Route path="/map" element={<Map />} />
          {/* Projects route */}
          <Route path="/projects/*" element={<Projects />} />
          {/* Statuses route */}
          <Route path="/statuses/*" element={<Statuses />} />
          {/* Certifiers route */}
          <Route path="/certifiers/*" element={<Certifiers />} />
        </Routes>
      </div>

      {/* Sidebar */}
      <Sidebar
        visible={sidebarVisible}
        onHide={() => setSidebarVisible(false)}
        style={{ width: '250px' }}
      >
        <div style={{ padding: '1rem' }}>
          <h5 style={{ marginBottom: '1rem', color: '#495057' }}>Navegación</h5>
          <PanelMenu model={panelMenuItems} style={{ border: 'none' }} />
        </div>
      </Sidebar>
    </div>
  );
}

export default AppLayout;
